import MiddleSectionScreenView from "../../components/shared-components/MiddleSectionScreenView";
import Layout from "../../components/layout";
import AboutMiddleSection from "./AboutMiddleSection";
import AboutBottomSection from "./AboutBottomSection";
import { AboutHeroSection } from "./style";
import PortFolioSection from "../../components/shared-components/PortFolioSection";
import FeatureAbout from "./FeatureAbout";

const About = () => {
  return (
    <Layout fullScreen>
      <AboutHeroSection>
        <MiddleSectionScreenView />
      </AboutHeroSection>
      <AboutMiddleSection />
      <FeatureAbout />
      <AboutBottomSection/>
      <PortFolioSection />
    </Layout>
  );
};

export default About;
